function toggleAccordion(accordion, expand) {
  const content = accordion.querySelector('.accordion-content');

  if (expand) {
    accordion.classList.add('active');
    content.style.maxHeight = content.scrollHeight + 'px';
  } else {
    accordion.classList.remove('active');
    content.style.maxHeight = '0';
  }
}

document.querySelectorAll('.accordion').forEach((accordion) => {
  const header = accordion.querySelector('.accordion-header');
  const content = accordion.querySelector('.accordion-content');

  // Open on load if active
  if (accordion.classList.contains('active')) {
    content.style.maxHeight = content.scrollHeight + 'px';
  }

  header.addEventListener('click', () => {
    const isOpen = accordion.classList.contains('active');
    toggleAccordion(accordion, !isOpen);
  });

  // Ensure height is reset on transition end (nice cleanup)
  content.addEventListener('transitionend', () => {
    if (!accordion.classList.contains('active')) {
      content.style.maxHeight = '0';
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  });
});

// Utility: safe selector for attribute values
const esc = (v) => (CSS && CSS.escape ? CSS.escape(v) : v.replace(/(["\\])/g, '\\$1'));

document.addEventListener('click', (e) => {
  const trigger = e.target.closest('.cstm-product-sibling-picker__trigger');
  if (!trigger) return;

  e.preventDefault();

  // Find the nearest product group wrapper
  const groupEl = trigger.closest('[data-product-group]');
  if (!groupEl) return; // safety: do nothing if no group wrapper

  const productId = trigger.getAttribute('data-product-id');

  const cards = Array.from(groupEl.querySelectorAll('.cstm-card-product'));
  const triggers = Array.from(groupEl.querySelectorAll('.cstm-product-sibling-picker__trigger'));

  // Toggle cards only inside this group
  cards.forEach((card) => {
    const isMatch = card.getAttribute('data-product-id') === productId;
    card.classList.toggle('active', isMatch);
    card.classList.toggle('is-hidden', !isMatch);
  });

  // Toggle triggers only inside this group
  triggers.forEach((t) => {
    const isMatch = t.getAttribute('data-product-id') === productId;
    t.classList.toggle('active', isMatch);
  });
});

// collection load more
document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('#product-grid .product-card');
  const btn = document.getElementById('loadMoreBtn');
  let visible = 1;
  const step = 2; // number of products to show each time

  const reveal = () => {
    for (let i = visible; i < visible + step; i++) {
      if (items[i]) items[i].classList.remove('hidden');
    }
    visible += step;
    if (visible >= items.length) btn.style.display = 'none';
  };

  btn?.addEventListener('click', reveal);

  // Optional: auto load on scroll
  window.addEventListener('scroll', () => {
    if (!btn) return;
    const rect = btn.getBoundingClientRect();
    if (rect.top < window.innerHeight) {
      reveal();
    }
  });
});

function updateStockUsp(variant) {
  const uspBlock = document.querySelector('.cstm-usp');
  if (!uspBlock) return;

  const dot = uspBlock.querySelector('.blob');
  const label = uspBlock.querySelector('span:last-child');

  if (!variant || !variant.available) {
    dot.className = 'blob red';
    label.textContent = window.stockUspText.outOfStock;
  } else {
    dot.className = 'blob orange';
    label.textContent = window.stockUspText.almostOutOfStock;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const variant = event.data?.variant;
    updateStockUsp(variant);
  });
});

function updateDeliveryDate() {
  const el = document.getElementById('dynamicdeliverydate');
  if (!el) return;

  const now = new Date();
  const nextDay = new Date(now);
  nextDay.setDate(nextDay.getDate() + 1);

  if (nextDay.getDay() === 0) {
    nextDay.setDate(nextDay.getDate() + 1);
  }

  const day = nextDay.getDate();

  const months = [
    'januari',
    'februari',
    'maart',
    'april',
    'mei',
    'juni',
    'juli',
    'augustus',
    'september',
    'oktober',
    'november',
    'december',
  ];

  el.textContent = `${day} ${months[nextDay.getMonth()]}`;
}

updateDeliveryDate();
